import { LegalLayout, H2, P, Ul, Li, A } from "./LegalLayout.jsx";

export default function CookiePage() {
  return (
    <LegalLayout title="Cookie Policy" lastUpdated="27 April 2026">

      <P>This policy explains what cookies and local storage NomLoop uses and why.
      It should be read alongside our <A href="/privacy">Privacy Policy</A>.</P>

      <H2>What is a cookie?</H2>
      <P>A cookie is a small text file stored on your device by your browser when
      you visit a website. NomLoop also uses <em>local storage</em> — a similar
      mechanism — to remember your choices across sessions.</P>

      <H2>Strictly necessary (always on)</H2>
      <P>These cannot be switched off — they are required for the service to work.
      They do not store any personally identifiable information.</P>
      <Ul>
        <Li><strong>nomloop_jwt</strong> — stores your authentication token after
        sign-in so you stay logged in across page loads. Expires after 30 days.</Li>
        <Li><strong>nomloop_cookie_consent</strong> — stores your cookie preference
        ("accepted" or "rejected"). Persists until you clear browser storage.</Li>
        <Li><strong>nomloop.checkoutCount</strong> — counts how many times you've
        confirmed a weekly shop. Used to unlock the cooking reel feature. Never
        sent to our server.</Li>
        <Li><strong>Session token (memory only)</strong> — a short-lived identifier
        kept in page memory (not written to disk) to secure API calls. Lost when
        you close the tab.</Li>
      </Ul>

      <H2>Analytics cookies (optional — consent required)</H2>
      <P>We ask for your consent before setting these. If you decline, none of the
      following are set.</P>
      <Ul>
        <Li><strong>Analytics provider cookies</strong> — used to understand how
        people use NomLoop (which screens are visited, where people drop off). This
        helps us improve the product. No data is sold or used for advertising.</Li>
      </Ul>

      <H2>Third-party cookies set by Awin (affiliate tracking)</H2>
      <P>When you click a grocery link, your browser is redirected through{" "}
      <A href="https://www.awin.com">Awin's</A> servers. Awin may set a cookie on
      their domain to track whether your visit resulted in a purchase, so they can
      attribute commission. This is standard affiliate industry practice. Awin's
      own <A href="https://www.awin.com/gb/legal/privacy-policy">Privacy Policy</A>{" "}
      applies to their cookies.</P>

      <H2>How to control cookies</H2>
      <Ul>
        <Li><strong>In NomLoop</strong> — your analytics cookie preference is stored
        in local storage under <code>nomloop_cookie_consent</code>. To reset it,
        clear your browser's site data for nomloop.uk.</Li>
        <Li><strong>In your browser</strong> — all major browsers let you block or
        delete cookies. Note that blocking strictly necessary cookies will break
        sign-in and other core features.</Li>
        <Li><strong>Awin opt-out</strong> — visit{" "}
        <A href="https://www.awin.com/gb/legal/privacy-policy">Awin's privacy page</A>{" "}
        to opt out of their affiliate tracking cookie.</Li>
      </Ul>

      <H2>Changes to this policy</H2>
      <P>We'll update this page if we change the cookies we use. Check the "Last
      updated" date at the top of this page.</P>

    </LegalLayout>
  );
}
